/* eslint-disable no-param-reassign */

import { getParent, types } from "mobx-state-tree";

const MessageModel = types
  .model("MessageModel", {
    id: types.identifier,
    text: types.string,
    image: types.maybeNull(types.string),
    createdAt: types.string,
    fastReadingIsPaid: types.maybeNull(types.boolean),
    premiumPurchaseId: types.maybeNull(types.string),
    hasBooking: types.maybeNull(types.boolean),
    fromConsultant: false,
    fromContact: false,
    fromUser: false,
    user: types.model({
      id: types.number,
      avatar: types.maybeNull(types.string),
      name: types.string,
    }),
  })
  .views((self) => ({
    get createdAtJSDate() {
      return new Date(self.createdAt);
    },

    get isOld() {
      const parent = getParent(self, 2);
      return new Date(self.createdAt) < parent.startedAt;
    },
  }));

export default MessageModel;
